<template>
  <div class="contact_box body-box">
    <div class="div-img-top body-width divcss5">
      <div class="font_zh">
        <span>{{$t('contact.contactus')}}</span>
      </div>
      <div class="font_en font_en_top">CONTACT US</div>
    </div>
    <div class="row contact_body">
      <div class="border_right_line">
        <div class="contact_info">
          <div class="contact_phone">
            <img src="../../../assets/images/contactus/contactus_phone.png" />
            <span>0411-84978997</span>
          </div>
          <div class="contact_mail contact_top_padding">
            <img src="../../../assets/images/contactus/contact_mail.png" />
            <span>sales@zlonmarine.com</span>
          </div>
          <div class="contact_web contact_top_padding">
            <img src="../../../assets/images/contactus/contactus_web.png" />
            <span>www.zlonmarine.com</span>
          </div>
          <div class="contact_top_padding">
            <img src="../../../assets/images/contactus/contactus_position.png" />
            <span>{{$t('contact.location')}}</span>
          </div>
        </div>
      </div>
      <div class="border_right_line">
        <div class="contact_qrcode">
          <img src="../../../assets/images/contactus/qrcode.png" />
        </div>
      </div>
      <div class="contact_map">
        <baidu-map
          class="bm_view"
          :center="center"
          :zoom="zoom"
          @ready="handler"
          :auto-resize="autoResize"
          :scroll-wheel-zoom="scrollWheelZoom"
        >
          <bm-marker :position="center">
            <!-- <bm-label content="大连海大智龙科技有限公司" :labelStyle="{color: '#2E79BE', fontSize : '14px'}" :offset="{width: -35, height: 30}"/>-->
          </bm-marker>
        </baidu-map>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contactpartcontent",
  data() {
    return {
      // 经纬度
      center: { lng: 0, lat: 0 },
      // 缩放等级
      zoom: 3,
      //允许自适应容器尺寸
      autoResize: true,
      //允许鼠标滚轮缩放
      scrollWheelZoom: true
    };
  },
  methods: {
    handler({ BMap, map }) {
      this.center.lng = 121.5393846037;
      this.center.lat = 38.8723080005;
      this.zoom = 15;
    }
  }
};
</script>

<style scoped>
/*字体*/
.font_zh {
  font-size: 24px;
  color: #0d3e88;
}
.font_en {
  font-size: 16px;
  color: #2e79be;
}
.contact_body {
  padding-top: 40px;
  height: 230px;
}
.contact_info {
  text-align: left;
  padding-right: 26px;
}
.contact_map {
  padding-left: 30px;
}
.border_right_line {
  background-image: url(../../../assets/images/contactus/contactus_line.png);
  background-position: right 0;
  background-repeat: no-repeat;
}
.contact_phone {
  padding-top: 40px;
}
.contact_info span {
  /*    padding-left: 10px;*/
  font-size: 14px;
  color: #333333;
}
.contact_top_padding {
  padding-top: 16px;
}
.contact_qrcode {
  padding-top: 30px;
  width: 224px;
}
/* 地图容器必须设置宽和高属性 */
.bm_view {
  width: 470px;
  height: 230px;
}
.row {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/indexcontentcoms/contactpartcontent.vue